import { cn } from "@/lib/utils";
import type { CSSProperties } from "react";
import type { ViolationGroupInfo } from "@/services/validation";

/** `TdShiftCodeButton`의 `violationGroups` 항목과 `ViolationGroupInfo` 모두 수용 */
type ViolationGroupBarInput = Pick<
  ViolationGroupInfo,
  "type" | "startDay" | "endDay" | "isStart" | "isEnd"
> &
  Partial<Pick<ViolationGroupInfo, "pattern" | "rangeLength">>;

type ViolationGroupBarCodeProps = {
  group: ViolationGroupBarInput;
  className?: string;
  style?: CSSProperties;
};

/**
 * 설정/최소인원 등 위반 구간을 붉은 바로 묶어 표시 (시작 셀에서만 렌더)
 */
export default function ViolationGroupBarCode({
  group,
  className,
  style,
}: ViolationGroupBarCodeProps) {
  const rangeLen = group.rangeLength ?? 1;

  return (
    <div
      className={cn(
        "violation-group-bar",
        "absolute top-1/2 z-10 pointer-events-none -translate-y-1/2 left-[2px] border-3 rounded-sm bg-red-400/30 border-red-500",
        "animate-in fade-in duration-300",
        rangeLen === 1 ? "size-7.5" : "h-7.5",
        className
      )}
      data-violation-type={group.type}
      style={{
        willChange: "opacity, transform",
        ...(rangeLen > 1 ? { width: `calc(${rangeLen} * 100% - 4px)` } : {}),
        ...style,
      }}
    >
      <div className="absolute -right-[6px] rounded-full -top-[6px] size-2 bg-red-500" />
    </div>
  );
}
